
import { defineComponent, ref, onMounted, onUnmounted, computed, h } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import ExportCustomerModal from "@/components/modals/forms/ExportCustomerModal.vue";
import AddCustomerModal from "@/components/modals/forms/AddCustomerModal.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import streams from "./streams";
import { IStreams } from "./streams";
import { getStreams, deleteStream, deleteManyStream } from "./streams";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import ApiService from "@/core/services/ApiService";
import { getMedia } from "../master/media/media";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { profileSource } from "@/global-helper/handler";
import emitter from "@/eventBus";

export default defineComponent({
  name: "daftar-berita",
  components: {
    Datatable,
    ExportCustomerModal,
    AddCustomerModal,
  },
  setup() {
    const checkedNews: any = ref<Array<string>>([]);
    const tableData = ref<Array<IStreams>>(streams);
    const tableKey = ref(0);
    const total_data = ref(0);
    const router = useRouter();
    const is_loading = ref(true);
    const store = useStore();
    const role = store.getters.currentUser.data.role;
    const author: any = ref(null)
    const dataUser = ref([]);
    const dataSource = ref([
      {
        label: "Media Online",
        value: "news",
        type: 'medkon',
      },
      {
        label: "Media Cetak",
        value: "media_cetak",
        type: 'medkon',
      },
      {
        label: "Media TV",
        value: "media_tv",
        type: 'medkon',
      },
      {
        label: "Radio",
        value: "radio",
        type: 'medkon',
      },
      {
        label: "Running Text",
        value: "running_text",
        type: 'medkon',
      },
      {
        label: "Twitter",
        value: "twitter",
        type: 'medsos',
      },
      {
        label: "Facebook",
        value: "facebook",
        type: 'medsos',
      },
      {
        label: "Instagram",
        value: "instagram",
        type: 'medsos',
      },
      {
        label: "Youtube",
        value: "youtube",
        type: 'medsos',
      },
      {
        label: "Tiktok",
        value: "tiktok",
        type: 'medsos',
      },
      {
        label: "Forum",
        value: "forum",
      },
      {
        label: "Blog",
        value: "blog",
        type: 'medsos',
      },
      {
        label: "Linkedin",
        value: "linkedin",
        type: 'medsos',
      },
      {
        label: "Review Aplikasi",
        value: "review",
        type: 'medsos',
      },
      {
        label: "Threads",
        value: "threads",
        type: 'medsos',
      },
    ]);
    const dataJenisData = ref<any>([])
    const mediaSource = ref([]);
    const modelSelect = ref<any>({
      account: "",
      username: "",
      jenis_data: [],
      fullname: "",
      source: "",
    });
    const filterTanggal = ref([]);
    const filterTanggalShortcut = ref([
      {
        text: "Hari Ini",
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setHours(0, 0, 0);
          return [start, end];
        },
      },
      {
        text: "Kemarin",
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setDate(start.getDate() - 1);
          start.setHours(0, 0, 0);
          end.setDate(end.getDate() - 1);
          end.setHours(23, 59, 59);
          return [start, end];
        },
      },
      {
        text: "Seminggu Lalu",
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setDate(start.getDate() - 7);
          start.setHours(0, 0, 0);
          end.setHours(23, 59, 59);
          return [start, end];
        },
      },
      {
        text: "Bulan Ini",
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setDate(1);
          start.setHours(0, 0, 0);
          return [start, end];
        },
      },
      {
        text: "Bulan Lalu",
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setDate(1);
          start.setMonth(start.getMonth() - 1);
          start.setHours(0, 0, 0);
          end.setDate(0);
          end.setHours(23, 59, 59);
          return [start, end];
        },
      },
      {
        text: "Tahun Ini",
        value: () => {
          const end = new Date();
          const start = new Date();
          start.setMonth(0);
          start.setDate(1);
          start.setHours(0, 0, 0);
          return [start, end];
        },
      },
    ]);
    const defaultTime = ref([
      new Date(2000, 1, 1, 0, 0, 0),
      new Date(2000, 2, 1, 23, 59, 59),
    ]);
    const itemsPerPage = ref(10);
    const currentPage = ref(1);
    const search = ref<string>("");
    const is_select_all = ref(false);
    const mediaOptions = computed(() => {
      const medsos = [
        "twitter",
        "facebook",
        "instagram",
        "youtube",
        "tiktok",
        "linkedin",
        "forum",
        "blog",
        "review",
        "threads",
      ];
      if (modelSelect.value.source == "news") {
        return mediaSource.value.filter((el: any) => el.source == "news");
      } else if (modelSelect.value.source == "media_cetak") {
        return mediaSource.value.filter(
          (el: any) => el.source == "media_cetak"
        );
      } else if (modelSelect.value.source == "media_tv") {
        return mediaSource.value.filter((el: any) => el.source == "media_tv");
      } else if (medsos.includes(modelSelect.value.source)) {
        return [];
      } else {
        return mediaSource.value;
      }
    });
    const isHiddeJenisData = computed(() => {
      if (modelSelect.value.source) {
        const result = dataSource.value.find((el: any) => el.value === modelSelect.value.source);
        return result?.type === 'medkon';
      } else {
        return true;
      }
    });

    const tableHeader = computed(() => [
      {
        key: "checkbox",
      },
      {
        name: "Media",
        key: "account",
        sortable: true,
      },
      {
        name: "Source",
        key: "source",
        sortable: true,
      },
      ...(isHiddeJenisData.value ? [{
        name: "Jenis Berita",
        key: "jenis_data",
        sortable: true,
      }] : []),
      {
        name: "Judul",
        key: "title",
        sortable: true,
      },
      {
        name: "Diinput Oleh",
        key: "author",
        sortable: true,
      },
      {
        name: "File Berita",
        key: "file_source",
        sortingField: "file_source",
        sortable: true,
      },
      {
        name: "Tanggal Publikasi",
        key: "date",
        sortable: true,
      },
      {
        name: "Actions",
        key: "actions",
      },
    ]);

    const fetchStream = async () => {
      const payload = {
        ...(modelSelect.value.jenis_data.length > 0 ? { jenis_data: modelSelect.value.jenis_data } : {}),
        page: currentPage.value,
        limit: itemsPerPage.value,
      };
      if (filterTanggal.value.length > 0) {
        payload["start_date"] = moment(filterTanggal.value[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        payload["end_date"] = moment(filterTanggal.value[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      if (search.value.length > 0) {
        payload["keyword"] = search.value;
      }

      if (modelSelect.value.username != "") {
        payload["author"] = modelSelect.value.username;
      }
      if (modelSelect.value.account != "") {
        payload["account"] = modelSelect.value.account;
      }
      if (modelSelect.value.source != "") {
        payload["source"] = modelSelect.value.source;
      }
      is_loading.value = true;
      const res = await getStreams(payload);
      tableData.value = res["data"];
      total_data.value = res["total"];
      is_loading.value = false;
      tableKey.value += 1;
    };
    const fetchMedia = async (query) => {
      const res = await getMedia(query, "", 1, 100);
      res.data.forEach((el) => {
        if (el.source == "media_tv") {
          el.nama = el.stasiun || "Stasiun Tidak Diketahui";
        }
      });
      mediaSource.value = res.data.filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            (t) => t.nama.toLowerCase() === value.nama.toLowerCase()
          )
      );
    };
    const fetchUser = () => {
      const from_date = moment(filterTanggal.value[0]).format("YYYY-MM-DD HH:mm:ss");
      const to_date = moment(filterTanggal.value[1]).format("YYYY-MM-DD HH:mm:ss");

      ApiService.get(`/options/news-author?from_date=${from_date}&to_date=${to_date}`)
        .then((response) => {
          dataUser.value = response.data.author_data;
        })
        .catch((error) => {
          dataUser.value = [];
        });
    };
    const filterTanggalChange = async (value: any) => {
      currentPage.value = 1;
      if (value) {
        fetchUser();

        if (!(author.value && '_id' in author.value)) {
          author.value = null;
        }

        fetchStream();
      }
    };
    const filterAuthorChange = async (value: any) => {
      currentPage.value = 1;
      if (value) {
        author.value = value
        modelSelect.value.username = value.username;
      } else {
        author.value = null;
        modelSelect.value.username = "";
      }
      fetchStream();
    };
    const filterSourceChange = async (value) => {
      currentPage.value = 1;
      if (value) {
        modelSelect.value.source = value;
      } else {
        modelSelect.value.source = "";
      }

      modelSelect.value.jenis_data = "";
      getDataOptionsType("");
      fetchStream();
    };
    const filterJenisDataChange = async (value) => {
      currentPage.value = 1;
      if (value) {
        modelSelect.value.jenis_data = value;
      } else {
        modelSelect.value.jenis_data = "";
      }
      fetchStream();
    };
    const filterMediaChange = async (value: any) => {
      currentPage.value = 1;
      if (value) {
        modelSelect.value.account = value;
      } else {
        modelSelect.value.account = "";
        fetchMedia("");
      }
      fetchStream();
    };
    const formatDate = (date) => {
      let tanggal = moment(date).format("YYYY-MM-DD HH:mm:ss");
      return tanggal;
    };
    const defaultDate = () => {
      const end = new Date();
      const start = new Date();
      start.setDate(start.getDate() - 7);
      start.setHours(0, 0, 0);
      end.setHours(23, 59, 59);
      let arrayDate: any = [];
      arrayDate.push(start, end);
      filterTanggal.value = arrayDate;
    };
    const checkAll = () => {
      if (is_select_all.value) {
        checkedNews.value = [];
        tableData.value.forEach((el: any) => {
          checkedNews.value.push(el._id);
        });
      } else {
        checkedNews.value = [];
      }
    };
    const deleteSelectedNews = () => {
      Swal.fire({
        title: "Apakah anda yakin ingin menghapus berita tersebut?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Tidak",
        confirmButtonText: "Ya",
      }).then(async (result) => {
        if (result.value) {
          const res = await deleteManyStream(checkedNews.value);
          if (res.status == 200) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              toast: true,
              title: "Berhasil! Berita berhasil dihapus",
              showConfirmButton: false,
              timer: 3000,
            });
            checkedNews.value = [];
            fetchStream();
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              toast: true,
              title: "Gagal! Berita gagal dihapus",
              showConfirmButton: false,
              timer: 3000,
            });
          }
        }
      });
    };
    const searchItems = () => {
      if (search.value.length > 3) {
        fetchStream();
      } else if (search.value.length == 0) {
        fetchStream();
      }
    };
    const goToRoute = (id: string, name: string, detail: boolean) => {
      if (detail) {
        window.open("/berita/detail/" + id);
      } else {
        router.push({ name: name, params: { id: id } });
      }
    };
    const currentChange = (current: number) => {
      currentPage.value = current;
      fetchStream();
    };
    const itemsPerPageChange = (currentItemsPerPage: number) => {
      itemsPerPage.value = currentItemsPerPage;
      fetchStream();
    };
    const deleteBerita = (id) => {
      Swal.fire({
        title: "Apakah anda yakin ingin menghapus berita tersebut?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Tidak",
        confirmButtonText: "Ya",
      }).then(async (result) => {
        if (result.value) {
          const res = await deleteStream(id);
          if (res.message == "Stream has been deleted") {
            Swal.fire({
              position: "top-end",
              icon: "success",
              toast: true,
              title: "Berhasil! Berita berhasil dihapus",
              showConfirmButton: false,
              timer: 3000,
            });
            fetchStream();
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              toast: true,
              title: "Gagal! Berita gagal dihapus",
              showConfirmButton: false,
              timer: 3000,
            });
          }
        }
      });
    };

    const getDataOptionsType = (key) => {
      const params: any = {
        ...(key ? { key } : {}),
        ...(modelSelect.value.source ? { source: modelSelect.value.source } : {})
      }

      const query = Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join("&");

      ApiService.get(`/options/news-type?${query}`)
        .then((response) => {
          const order = ["news", "media_cetak", "media_tv", "radio", "running_text"];

          dataJenisData.value = response.data.news_type_data.sort(
            (a, b) => order.indexOf(a.source) - order.indexOf(b.source)
          );
        })
        .catch((error) => {
          dataJenisData.value = [];
        });
    }

    const checkSource = (source) => {
      const result = dataSource.value.find((el: any) => el.value === source);

      return result;
    };

    onMounted(() => {
      setCurrentPageTitle("Daftar Berita");
      defaultDate();
      fetchStream();
      fetchUser();
      fetchMedia("");
      getDataOptionsType("");

      emitter.emit("set-toolbar-content", {
        render() {
          return h("div", { class: "d-flex gap-2" }, [
            h("a", {
              class: "btn btn-primary btn-sm",
              href: "/ocr-tools/pwa/index.html",
              target: "_blank",
            }, "Buka Aplikasi OCR")
          ]);
        }
      });
    });

    onUnmounted(() => {
      emitter.emit("set-toolbar-content", null);
    });

    return {
      tableData,
      tableHeader,
      search,
      searchItems,
      is_select_all,
      checkAll,
      checkedNews,
      deleteSelectedNews,
      fetchStream,
      fetchMedia,
      mediaOptions,
      tableKey,
      total_data,
      goToRoute,
      is_loading,
      filterTanggal,
      filterTanggalShortcut,
      filterTanggalChange,
      filterMediaChange,
      currentChange,
      itemsPerPageChange,
      itemsPerPage,
      currentPage,
      defaultTime,
      role,
      dataUser,
      author,
      dataSource,
      dataJenisData,
      modelSelect,
      filterAuthorChange,
      filterSourceChange,
      filterJenisDataChange,
      formatDate,
      deleteBerita,
      mediaSource,
      profileSource,
      getDataOptionsType,
      isHiddeJenisData,
      checkSource,
    };
  },
});
